import { useState } from "react";
import { RelativeUrl } from "@adora/shared/utils/environment";
import deleteRequest from "@adora/shared/utils/delete";

const useMutateAdAssets = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteAdAsset = async (id: number, brandId: number): Promise<boolean> => {
    setIsLoading(true);
    setError(null);

    await deleteRequest(`${RelativeUrl}/ad_assets/${id}?brand_id=${brandId}`);

    setIsLoading(false);

    return true;
  };

  return {
    deleteAdAsset,
    isLoading,
    error
  };
};

export default useMutateAdAssets;
